import ConceptBase from '../concept_base';

class ConceptsTest extends ConceptBase {
  constructor(projectData, priceData, size) {
    super(projectData, priceData, size);
  }
}

export default ConceptsTest;
